import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundTimeStore } from '../../../store';

export const Timer = observer(() => {
  const { time, duration, passedSeconds } = roundTimeStore;

  return time ? (
    <div className='game-content-holder'>
      <div className='game-content-wrap'>
        <>
          <svg
            id='Group_12860'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            width='70'
            height='70'
            viewBox='0 0 70 70'
          >
            <defs>
              <clipPath id='clip-path'>
                <rect id='Rectangle_4002' width='14.072' height='14.073' fill='#2a2b2c' />
              </clipPath>
              <clipPath id='clip-path-2'>
                <rect id='Rectangle_4003' width='15.432' height='8.937' fill='#2a2b2c' />
              </clipPath>
              <clipPath id='clip-path-3'>
                <rect id='Rectangle_4004' width='8.937' height='15.432' fill='#2a2b2c' />
              </clipPath>
              <clipPath id='clip-path-4'>
                <rect id='Rectangle_4005' width='8.938' height='15.432' fill='#2a2b2c' />
              </clipPath>
              <clipPath id='clip-path-5'>
                <rect id='Rectangle_4006' width='14.072' height='14.072' fill='#2a2b2c' />
              </clipPath>
            </defs>
            <g id='Group_12716' transform='translate(50.625 50.625)' opacity='0.7'>
              <g id='Group_12715'>
                <g id='Group_12714' clipPath='url(#clip-path)'>
                  <path
                    id='Path_66173'
                    d='M54.594,286.944l4.668,2.917a35.247,35.247,0,0,1-11.155,11.155l-2.917-4.668a29.712,29.712,0,0,0,9.4-9.4'
                    transform='translate(-45.19 -286.944)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
            <g id='Group_12719' transform='translate(36.019 61.062)' opacity='0.7'>
              <g id='Group_12718'>
                <g id='Group_12717' clipPath='url(#clip-path-2)'>
                  <path
                    id='Path_66174'
                    d='M128.718,342.519l2.584,4.861a34.875,34.875,0,0,1-15.24,4.077l-.192-5.5a29.4,29.4,0,0,0,12.847-3.437'
                    transform='translate(-115.871 -342.519)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
            <g id='Group_12722' transform='translate(61.063 36.019)' opacity='0.7'>
              <g id='Group_12721'>
                <g id='Group_12720' clipPath='url(#clip-path-3)'>
                  <path
                    id='Path_66175'
                    d='M20.394,209.025l5.5.192a34.871,34.871,0,0,1-4.077,15.24l-4.861-2.584a29.4,29.4,0,0,0,3.437-12.847'
                    transform='translate(-16.957 -209.025)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
            <path
              id='Path_66176'
              d='M301.015,296.348l-2.917,4.668a35.246,35.246,0,0,1-11.155-11.156l4.668-2.917a29.712,29.712,0,0,0,9.4,9.4'
              transform='translate(-281.641 -236.319)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <path
              id='Path_66177'
              d='M351.457,221.872l-4.86,2.584a34.875,34.875,0,0,1-4.077-15.239l5.5-.192a29.4,29.4,0,0,0,3.437,12.847'
              transform='translate(-342.52 -173.006)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <path
              id='Path_66178'
              d='M224.457,345.956l-.192,5.5a34.87,34.87,0,0,1-15.24-4.077l2.584-4.861a29.4,29.4,0,0,0,12.847,3.437'
              transform='translate(-190.476 -281.457)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <g id='Group_12725' transform='translate(61.062 18.549)' opacity='0.7'>
              <g id='Group_12724' transform='translate(0)'>
                <g id='Group_12723' clipPath='url(#clip-path-4)'>
                  <path
                    id='Path_66179'
                    d='M16.957,118.455l4.861-2.584a34.872,34.872,0,0,1,4.077,15.24l-5.5.192a29.4,29.4,0,0,0-3.437-12.847'
                    transform='translate(-16.957 -115.871)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
            <path
              id='Path_66180'
              d='M291.612,59.263l-4.668-2.917A35.243,35.243,0,0,1,298.1,45.191l2.917,4.668a29.715,29.715,0,0,0-9.4,9.4'
              transform='translate(-281.642 -39.889)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <path
              id='Path_66181'
              d='M211.609,25.9l-2.584-4.86a34.875,34.875,0,0,1,15.24-4.077l.192,5.5A29.4,29.4,0,0,0,211.609,25.9'
              transform='translate(-190.476 -16.959)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <path
              id='Path_66182'
              d='M348.019,131.3l-5.5-.192a34.871,34.871,0,0,1,4.077-15.239l4.86,2.584a29.4,29.4,0,0,0-3.437,12.847'
              transform='translate(-342.519 -97.323)'
              fill='#2a2b2c'
              opacity='0.7'
            />
            <g id='Group_12728' transform='translate(50.625 5.302)' opacity='0.7'>
              <g id='Group_12727'>
                <g id='Group_12726' clipPath='url(#clip-path-5)'>
                  <path
                    id='Path_66183'
                    d='M45.19,49.86l2.917-4.668A35.244,35.244,0,0,1,59.262,56.347l-4.668,2.917a29.714,29.714,0,0,0-9.4-9.4'
                    transform='translate(-45.19 -45.192)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
            <g id='Group_12731' transform='translate(36.019 0)' opacity='0.7'>
              <g id='Group_12730' transform='translate(0 0)'>
                <g id='Group_12729' clipPath='url(#clip-path-2)'>
                  <path
                    id='Path_66184'
                    d='M115.872,22.459l.192-5.5A34.872,34.872,0,0,1,131.3,21.036l-2.584,4.86a29.4,29.4,0,0,0-12.847-3.437'
                    transform='translate(-115.872 -16.959)'
                    fill='#2a2b2c'
                  />
                </g>
              </g>
            </g>
          </svg>
          {/*<svg className="spinner-countdown" viewBox="0 0 33.83098862 33.83098862" width="70" height="70" xmlns="http://www.w3.org/2000/svg">*/}
          {/*<circle className="spinner-countdown__background" stroke="none" strokeWidth="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />*/}
          {/*<circle className="spinner-countdown__circle" style={{ animationDuration: `10s` }} stroke="#FFBC15" strokeWidth="2" strokeDasharray="100,100" strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />*/}
          {/*</svg>;*/}

          <svg
            xmlns='http://www.w3.org/2000/svg'
            xmlns='http://www.w3.org/2000/svg'
            className='spinner-countdown'
            viewBox='0 0 33.83098862 33.83098862'
            width='70'
            height='70'
          >
            <circle
              className='spinner-countdown__circle'
              style={{ animationDuration: `${duration}s`, animationDelay: `-${passedSeconds}s` }}
              strokeWidth='2'
              strokeDasharray='100,100'
              fill='none'
              cx='16.91549431'
              cy='16.91549431'
              r='15.91549431'
              stroke='#FF008C'
            />
            <g style={{ transform: 'scale(0.48333)' }}>
              <g>
                <path
                  d='M36.5,0v4.1c-0.5,0-1,0-1.5,0c0,0,0,0,0,0h-0.1c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0-0.6,0V0c0.5,0,0.9,0,1.4,0
			H35C35.5,0,36,0,36.5,0z'
                />
                <path d='M36.5,65.8V70c-0.5,0-1,0-1.5,0s-1,0-1.5,0v-4.2c0.5,0,1,0,1.5,0S36,65.8,36.5,65.8z' />
              </g>
              <path d='M4.1,35c0,0.5,0,1,0,1.5H0c0-0.5,0-1,0-1.5c0-0.5,0-1,0-1.5h4.1C4.1,34,4.1,34.5,4.1,35z' />
              <path d='M70,35c0,0.5,0,1,0,1.5h-4.1c0-0.5,0-1,0-1.5s0-1,0-1.5H70C70,34,70,34.5,70,35z' />
              <g>
                <path
                  d='M9,51.7l-1.8,1l-1.8,1.1c-0.5-0.8-1-1.7-1.5-2.6l1.8-1.1l1.8-1h0C8,50,8.5,50.8,9,51.7C9,51.6,9,51.7,9,51.7z
			'
                />
                <path
                  d='M66,18.8l-1.8,1.1l-1.8,1c-0.4-0.8-0.8-1.5-1.3-2.2c-0.1-0.1-0.1-0.2-0.2-0.3l1.8-1l1.8-1
			C65.1,17.1,65.6,17.9,66,18.8z'
                />
              </g>
              <g>
                <path
                  d='M20.9,7.6c-0.4,0.2-0.7,0.4-1.1,0.6c-0.2,0.1-0.4,0.2-0.6,0.4c0,0,0,0-0.1,0c-0.2,0.1-0.4,0.2-0.5,0.3
			c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1l-1-1.8l-1-1.8c0.8-0.5,1.7-1,2.6-1.5l1,1.8L20.9,7.6z'
                />
                <path
                  d='M53.7,64.6c-0.8,0.5-1.7,1-2.6,1.5l-1-1.8l-1-1.8l0,0c0.9-0.4,1.7-0.9,2.5-1.4c0,0,0,0,0.1-0.1l1,1.8
			L53.7,64.6z'
                />
              </g>
              <path
                d='M9.3,17.9c-0.3,0.4-0.5,0.8-0.8,1.3c-0.2,0.4-0.5,0.8-0.7,1.2c0,0-0.1,0.1-0.1,0.2L6,19.4l-1.8-1.1
		c0.5-0.9,1-1.7,1.5-2.6l1.7,1.1L9.3,17.9z'
              />
              <path
                d='M65.8,51.7c-0.5,0.9-1,1.7-1.5,2.6l-1.8-1.1l-1.8-1.1l0,0c0.3-0.4,0.5-0.8,0.8-1.3c0.3-0.4,0.5-0.9,0.7-1.3
		l1.8,1.1L65.8,51.7z'
              />
              <g>
                <path
                  d='M20.5,62.2L20.5,62.2L19.4,64l-1.1,1.8c-0.9-0.5-1.7-1-2.6-1.5l1.1-1.8l1.1-1.8v0
			C18.7,61.2,19.6,61.8,20.5,62.2z'
                />
                <path
                  d='M54.2,5.8l-1.1,1.8l-1.1,1.8c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1-0.1-0.1-0.1c-0.2-0.1-0.5-0.3-0.7-0.4
			c-0.4-0.2-0.8-0.5-1.2-0.7c-0.1,0-0.1-0.1-0.2-0.1L50.6,6l1.1-1.8C52.5,4.7,53.4,5.2,54.2,5.8z'
                />
              </g>
            </g>
          </svg>
          <div className='loading-time'>{time}</div>
        </>
      </div>
    </div>
  ) : (
    <></>
  );
});
